export enum OrderTypeEnum {
  Market = 0,
  Limit = 1,
  Stop = 2,
  MarketClose = 3,
  TP = 4,
  None = 255
}
